const global = {
    // local_url:'//pigai-dev.d.eoffcn.com',
    local_url: '//pigai.t.eoffcn.com',
    test_url:'//pigai.t.eoffcn.com',
    online_url:'//pigai.eoffcn.com',
    tiku_local:'//tiku.t.eoffcn.com',
    tiku_test_url: '//tiku.t.eoffcn.com',
    tiku_online_url:'//tiku.eoffcn.com',
    paper_local_url:'//iip.d.eoffcn.com',
};
export default {
  global
}



// WEBPACK FOOTER //
// ./src/global/index.js